import React, { useState } from "react";
import "./area-table.scss";
import Table from "./table";
import { Column } from "../../../types/column";
import { get } from "lodash";

type Row = {
  id: number;
  name: string;
  date: string;
  customer: string;
  status: string;
  amount: number;
};

const columns: Column[] = [
  {
    id: 1,
    title: "Order ID",
    prop: "order_id",
    hover: true,
    width: "minmax(40px, 280px)",
    hideHead: false,
  },
  {
    id: 2,
    title: "Products",
    prop: "name",
    hover: true,
    width: "minmax(40px, 280px)",
    hideHead: false,
  },
  {
    id: 3,
    title: "Customer name",
    prop: "customer",
    hover: true,
    width: "minmax(30px, 340px)",
    hideHead: false,
  },
  {
    id: 4,
    title: "Amount",
    prop: "amount",
    hover: true,
    width: "minmax(150px, 290px)",
    type: "number",
    postfix: "$",
    hideHead: false,
  },
  {
    id: 5,
    title: "Status",
    prop: "status",
    hover: false,
    width: "minmax(40px, 500px)",
    type: "status-cell",
    hideHead: false,
  },
  {
    id: 6,
    title: "Date",
    prop: "date",
    hover: true,
    width: "minmax(40px, 100px)",
    type: "",
    hideHead: false,
  },
  {
    id: 7,
    title: "",
    prop: "delete",
    hover: false,
    width: "80px",
    type: "delete",
    hideHead: false,
  },
];
const TABLE_DATA = [
  {
    id: 100,
    name: "Iphone 13 Pro",
    order_id: 11232,
    date: "Jun 29,2022",
    customer: "Afaq Karim",
    status: "delivered",
    amount: 400,
  },
  {
    id: 101,
    name: "Macbook Pro",
    order_id: 11232,
    date: "Jun 29,2022",
    customer: "Afaq Karim",
    status: "pending",
    amount: 288,
  },
  {
    id: 102,
    name: "Apple Watch",
    order_id: 11232,
    date: "Jun 29,2022",
    customer: "Afaq Karim",
    status: "canceled",
    amount: 500,
  },
  {
    id: 103,
    name: "Microsoft Book",
    order_id: 11232,
    date: "Jun 29,2022",
    customer: "Afaq Karim",
    status: "delivered",
    amount: 100,
  },
  {
    id: 104,
    name: "Apple Pen",
    order_id: 11232,
    date: "Jun 29,2022",
    customer: "Afaq Karim",
    status: "delivered",
    amount: 60,
  },
  {
    id: 105,
    name: "Airpods",
    order_id: 11232,
    date: "Jun 29,2022",
    customer: "Afaq Karim",
    status: "delivered",
    amount: 80,
  },
];

const AreaTable = () => {
  const [areaData, setAreaData] = useState<Row[]>(TABLE_DATA);
  const deleteItem = (row: Row) => {
    const id = get(row, "id", null);

    if (id) {
      setAreaData((current) => current.filter((data) => data.id !== id));
    }
  };

  return (
    <section className="content-area-table">
      <div className="data-table-info">
        <h4 className="data-table-title">Latest Orders</h4>
      </div>
      <div className="data-table-diagram">
        <Table
          columns={columns}
          rows={areaData as Row[]}
          handleDelete={deleteItem}
        />
      </div>
    </section>
  );
};

export default AreaTable;
